;(function () {

    if (typeof gsap === 'undefined') {
        console.warn('GSAP is missing');
        return;
    }

    // 1. SUIVI GLOBAL DE LA SOURIS (Nécessaire pour connaître la position Y hors du parent)
    let globalMouseY = 0;
    window.addEventListener('mousemove', (e) => {
        globalMouseY = e.clientY;
    });

    const config = {
        pauseDuration: 1.5,
        //slideDuration: 1.2,
        slideDuration: 0.55,
        slideEase: 'expo.out', // cubic-bezier(0, 1, 0.45, 1)
        mouseFollowSpeed: 0.12,
        paddingY: 50
    };

    const getLabels = (root) => {
        const scope = root instanceof Element ? root : document;
        const labels = scope.matches && scope.matches('.a-label') ? [scope] : [];

        return labels.concat(Array.from(scope.querySelectorAll('.a-label')));
    };

    const initLabels = (root = document) => {
        const labels = getLabels(root);
        if (!labels.length) return;

        labels.forEach(label => {
            if (label.dataset.labelInit === 'true') return;
            label.dataset.labelInit = 'true';

        const textContainer = label.querySelector('.a-label__text');
        if (!textContainer) return;

        // --- Préparation du texte (inchangé) ---
        const originalWords = textContainer.innerText.split(' ').filter(Boolean);
        if (!originalWords.length) return;

        gsap.set(textContainer, { opacity: 0 });
        textContainer.innerHTML = '';

        const repeatCount = Math.max(10, Math.ceil(window.innerWidth / 50));

        for (let i = 0; i < repeatCount; i++) {
            originalWords.forEach((wordText, wordIndex) => {
                const span = document.createElement('span');
                span.className = 'a-label__word';
                span.dataset.wordIndex = wordIndex;
                span.textContent = wordText;
                textContainer.appendChild(span);
                textContainer.appendChild(document.createTextNode(' '));
            });
        }

        const allWords = Array.from(textContainer.getElementsByClassName('a-label__word'));
        const totalOriginalWords = originalWords.length;

        let currentIndex = 0;
        let isAnimating = false;

        // =================================================================
        // POSITIONNEMENT & EVENTS
        // =================================================================

        const isFixed = label.classList.contains('a-label--fixed');

        // On n'active la logique de mouvement que si ce n'est PAS fixed
        // Listeners standards
        const parent = label.parentElement;
        let isMouseInParent = false;
        parent.addEventListener('mouseenter', () => {
            isMouseInParent = true;
            setTimeout(() => {
                runSequence()
            }, "1500");
        });
        parent.addEventListener('mouseleave', () => { isMouseInParent = false; });


        if (!isFixed) {
            let currentY = 0; // Position actuelle lissée

            // Fonction utilitaire pour récupérer les limites (utilisée par mousemove ET l'event custom)
            function getBounds() {
                const parentRect = parent.getBoundingClientRect();
                const labelHeight = label.offsetHeight;
                return {
                    min: config.paddingY,
                    max: parent.offsetHeight - labelHeight - config.paddingY,
                    parentTop: parentRect.top
                };
            }

            // Boucle d'animation standard (Hover image)
            function updatePosition() {
                if (!isMouseInParent) {
                    requestAnimationFrame(updatePosition);
                    return;
                }

                const bounds = getBounds();

                // Ici on utilise globalMouseY qui est toujours à jour
                const targetY = globalMouseY - bounds.parentTop - (label.offsetHeight / 2);
                const clampedY = Math.max(bounds.min, Math.min(bounds.max, targetY));

                currentY += (clampedY - currentY) * config.mouseFollowSpeed;

                gsap.set(label, { y: currentY });

                requestAnimationFrame(updatePosition);
            }


            // Lancer la boucle
            requestAnimationFrame(updatePosition);

            // -----------------------------------------------------------
            // NOUVEAU : Écoute de l'événement custom LABEL:HOVERED
            // -----------------------------------------------------------
            document.addEventListener('LABEL:HOVERED', (e) => {
                // 1. Vérifier si l'event concerne la carte parent de ce label
                if (e.detail.card && e.detail.card.contains(label)) {

                    const bounds = getBounds();

                    // 2. Calculer la cible par rapport à la souris globale
                    const targetY = globalMouseY - bounds.parentTop - (label.offsetHeight / 2);

                    // 3. Limiter aux bornes (padding haut/bas)
                    // Si la souris est sur le titre (en dessous), clampedY sera = bounds.max
                    const clampedY = Math.max(bounds.min, Math.min(bounds.max, targetY));

                    // 4. Mettre à jour la variable interne currentY pour éviter les sauts
                    // si l'utilisateur repasse sur l'image ensuite
                    currentY = clampedY;

                    // 5. Appliquer immédiatement (avec une petite transition fluide)
                    gsap.to(label, {
                        y: clampedY,
                        duration: 0.4,
                        ease: 'power2.out',
                        overwrite: true // Assure que ça prend le dessus sur la boucle
                    });
                }
            });
        }


        // =================================================================
        // LOGIQUE TEXTE (Inchangé)
        // =================================================================
        function centerWord(word, animate = false, onComplete = null) {
            if (!word) return;
            const containerCenterX = label.offsetWidth / 2;
            const wordOffsetLeft = word.offsetLeft;
            const wordWidth = word.offsetWidth;
            const wordCenterInTextParams = wordOffsetLeft + (wordWidth / 2);
            const targetX = Math.round(containerCenterX - wordCenterInTextParams);

            if (animate) {
                gsap.to(textContainer, {
                    x: targetX,
                    duration: config.slideDuration,
                    ease: config.slideEase,
                    onComplete: onComplete
                });
            } else {
                gsap.set(textContainer, { x: targetX });
                if (onComplete) onComplete();
            }
        }

        function checkAndReposition() {
            const middleStartIndex = Math.floor(repeatCount / 2) * totalOriginalWords;
            const currentWordIndex = currentIndex % totalOriginalWords;
            const middleEquivalentIndex = middleStartIndex + currentWordIndex;

            if (Math.abs(currentIndex - middleEquivalentIndex) > totalOriginalWords) {
                if (allWords[currentIndex]) allWords[currentIndex].classList.remove('is-active');
                currentIndex = middleEquivalentIndex;
                if (allWords[currentIndex]) {
                    allWords[currentIndex].classList.add('is-active');
                    centerWord(allWords[currentIndex], false);
                }
            }
        }

        function runSequence() {
            if (!isMouseInParent) return;
            if (isAnimating) return;
            isAnimating = true;

            const nextIndex = currentIndex + 1;

            if (nextIndex >= allWords.length) {
                const middleStartIndex = Math.floor(repeatCount / 2) * totalOriginalWords;
                if (allWords[currentIndex]) allWords[currentIndex].classList.remove('is-active');
                currentIndex = middleStartIndex;
                if (allWords[currentIndex]) allWords[currentIndex].classList.add('is-active');
                centerWord(allWords[currentIndex], false);
                isAnimating = false;
                gsap.delayedCall(config.pauseDuration, runSequence);
                return;
            }

            const targetWord = allWords[nextIndex];

            if (allWords[currentIndex]) allWords[currentIndex].classList.remove('is-active');
            targetWord.classList.add('is-active');

            centerWord(targetWord, true, () => {
                currentIndex = nextIndex;
                isAnimating = false;
                checkAndReposition();
                gsap.delayedCall(config.pauseDuration, runSequence);
            });
        }

        function start() {
            const middleStartIndex = Math.floor(repeatCount / 2) * totalOriginalWords;
            currentIndex = middleStartIndex;

            const startWord = allWords[currentIndex];
            if (!startWord) return;

            document.fonts.ready.then(() => {
                startWord.classList.add('is-active');
                setTimeout(() => {
                    textContainer.offsetHeight;
                    centerWord(startWord, false);
                    gsap.to(textContainer, {
                        opacity: 1,
                        duration: 0.2,
                        onComplete: () => {
                            const randomDelay = Math.random() * 0.1;
                            gsap.delayedCall(config.pauseDuration + randomDelay, runSequence);
                        }
                    });
                }, 10);
            });
        }

        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                if (allWords[currentIndex]) centerWord(allWords[currentIndex], false);
            }, 100);
        });

            start();
        });
    };

    window.hdsInitLabels = initLabels;
    initLabels();

}());
